import { sanitizeTokenSymbol } from '../shared/sanitize';
import type { NetworkKey } from '../shared/config';

const TOKEN_LOGOS: Record<string, string> = {
  USDC: 'images/usdc.png',
  GVR: 'images/gvr.png',
};

const FALLBACK_LOGO = 'images/coin.svg';

export function tokenLabelHtml(baseUrl: string, symbol: string): string {
  const normalized = sanitizeTokenSymbol(symbol, 'TOKEN').toUpperCase();
  const logo = TOKEN_LOGOS[normalized] ?? FALLBACK_LOGO;
  return `<span class="token-inline"><img src="${baseUrl}${logo}" alt="${normalized}" class="token-logo"/>${normalized}</span>`;
}

export function showCopyFeedback(anchor: HTMLElement, message: string): void {
  const feedback = document.createElement('div');
  feedback.className = 'token-copy-feedback';
  feedback.textContent = message;

  const rect = anchor.getBoundingClientRect();
  feedback.style.left = `${Math.round(rect.right + 6)}px`;
  feedback.style.top = `${Math.round(rect.top + rect.height / 2)}px`;

  document.body.appendChild(feedback);
  window.setTimeout(() => feedback.remove(), 1100);
}

export function getBuyUsdcPulseXUrl(activeNetwork: NetworkKey, collateralAddress: string): string {
  const base = 'https://pulsex.mypinata.cloud/ipfs/bafybeiaq4jgcpz4hdzwid6letizdnhijlp6lu5ivcjcp5vbgpgf54jknn4/#/';
  if (activeNetwork === 'mainnet') {
    return `${base}?outputCurrency=${encodeURIComponent(collateralAddress)}`;
  }
  return `${base}?chain=pulsechain-testnet&outputCurrency=${encodeURIComponent(collateralAddress)}`;
}
